<template>
  <vk-modal-body>
    <vk-modal-header>
      The service {{ service.display_name }} is not available for {{ zipcode }}
    </vk-modal-header>
    <vk-modal-content>
      <div class="m-b-2">
        <!-- eslint-disable-next-line max-len -->
        We're sorry, we don't have pros in your area yet, but are working hard to expand our network so please check back soon.
      </div>
      <button
          class="btn"
          selenium="unavailable-modal-button-ok"
          @click="$emit('ok')">
        Ok
      </button>
    </vk-modal-content>
  </vk-modal-body>
</template>

<script>
export default {
  name: 'service-unavailable-modal',
  props: {
    service: {
      type: Object,
      required: true,
    },
    zipcode: {
      type: String,
      required: true,
    },
  },
  mounted () {
    const { service, zipcode } = this;
    this.$events.$emit(this.$events.REQUEST_NO_PROS_AVAILABLE, {
      service,
      zipcode,
    });
  },
};
</script>
